module.exports = __webpack_public_path__ + "img/294d9fa.png";